import React from 'react'
import Manager from '../../public/components/Manager'
import ForgetSwipeCardApplyDetail from './ForgetSwipeCardApplyDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
        { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
        { _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
        { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
        { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} readOnly={true} />)
    }
}

export default props => <Manager {...props} config={config} />